/**
 * Public self-registration (POST /auth/register) — co-op-wide toggle on site settings.
 */

import type { SiteSettings } from './types';

export const DEFAULT_REGISTRATION_CLOSED_MESSAGE =
  'We are not accepting new account registrations at this time.';

/** True when parents may self-register via /auth/register (default: allowed). */
export function isNewRegistrationAllowed(settings: SiteSettings): boolean {
  return settings.allowNewRegistrations !== false;
}

export function resolveRegistrationClosedMessage(message?: string | null): string {
  const trimmed = message?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : DEFAULT_REGISTRATION_CLOSED_MESSAGE;
}

/** Notice on the log in page when registrations are closed and the admin enabled it. */
export function shouldShowRegistrationClosedNotice(settings: SiteSettings): boolean {
  return (
    !isNewRegistrationAllowed(settings) && settings.showRegistrationClosedNotice === true
  );
}

export function registrationClosedNoticeText(settings: SiteSettings): string {
  return resolveRegistrationClosedMessage(settings.registrationClosedMessage);
}
